import { createFileRoute } from '@tanstack/react-router';

import { CommandPaletteSearchButton } from '@/app/GlobalCommandPalette/CommandPaletteSearchButton';
import { useOpenableCommands } from '@/app/GlobalCommandPalette/useOpenableCommands';
import { NotificationFeed } from '@/app/MagicBell/NotificationFeed/NotificationFeed';
import HomePage from '@/areas/home/Home/HomePage';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/home')({
    staticData: { access: { permissions: isInternalUser }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const navigationCommands = useOpenableCommands();
    return (
        <HomePage
            search={<CommandPaletteSearchButton telemetryLocation="welcome-banner" />}
            NotificationFeed={NotificationFeed}
            navigationCommands={navigationCommands}
        />
    );
}
